import { MultiSelectQuestion } from "./multi-select";

export default MultiSelectQuestion;
